import { type Components, type Theme } from "@mui/material/styles";

import {
  muiAvatarOverrides,
  muiBadgeOverrides,
  muiBottomNavigationOverrides,
  muiButtonOverrides,
  muiCardOverrides,
  muiCheckboxOverrides,
  muiChipOverrides,
  muiDialogOverrides,
  muiDrawerOverrides,
  muiIconButtonOverrides,
  muiInputOverrides,
  muiListOverrides,
  muiPaperOverrides,
  muiRatingOverrides,
  muiSkeletonOverrides,
  muiSliderOverrides,
  muiTabsOverrides,
  muiToggleButtonOverrides,
} from "./overrides";

export const muiThemeComponents: Components<Theme> = {
  ...muiAvatarOverrides,
  ...muiBadgeOverrides,
  ...muiBottomNavigationOverrides,
  ...muiButtonOverrides,
  ...muiCardOverrides,
  ...muiCheckboxOverrides,
  ...muiChipOverrides,
  ...muiDialogOverrides,
  ...muiDrawerOverrides,
  ...muiIconButtonOverrides,
  ...muiInputOverrides,
  ...muiListOverrides,
  ...muiPaperOverrides,
  ...muiRatingOverrides,
  ...muiSliderOverrides,
  ...muiTabsOverrides,
  ...muiToggleButtonOverrides,
  ...muiSkeletonOverrides,
};
